import { ChangeDetectionStrategy, Component, computed } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { CourtSystemParams, parentRouteParam, queryParam, routeParam } from '@ftr/routing-paths'

@Component({
  selector: 'ftr-forbidden-page',
  template: '<ftr-forbidden [courtSystemId]="courtSystemId()" />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ForbiddenPage {
  private readonly queryCourtSystemId = queryParam<Uuid | undefined>(CourtSystemParams.CourtSystemId)
  private readonly parentCourtSystemId = parentRouteParam<Uuid | undefined>(CourtSystemParams.CourtSystemId)
  private readonly routeCourtSystemId = routeParam<Uuid | undefined>(CourtSystemParams.CourtSystemId)

  protected readonly courtSystemId = computed(
    () => this.queryCourtSystemId() ?? this.parentCourtSystemId() ?? this.routeCourtSystemId(),
  )
}
